/* eslint-disable */

export const individualAdditionalFields = [
  'addressLineOne',
  'city',
  'county',
  'zipCode',
  'countryTwo',
  'countryThree',
  'gender',
  'dateOfBirth',
  'nationality',
  'passportNumber',
  'nationalIDNumber',
  'otherIDNumber',
];

export const companyAdditionalFields = [
  'addressLineOne',
  'city',
  'county',
  'zipCode',
  'countryTwo',
  'countryThree',
  'registrationNumber',
  'SWIFT',
  'companyUrl',
];
